export const SUPPORT_SETTINGS_TYPE = Object.freeze({
  BLIP     : 'blip',
  WHATSAPP : 'whatsapp'
});
